import _ from "lodash";
import { useFormContext } from "react-hook-form";


export const RangeSelector = ({
    id,
    min = 1,
    max = 100,
    value = 20,
    label,
    step = 1,
    name,
    required,
    metric = 'm',
    onChange = () => { }
}) => {
    const {
        register,
        watch
    } = useFormContext();


    return (
        <div className="w-full">
            {label && (
                <label htmlFor={id} className={`text-scogo99 font-normal text-font09 md:text-font11 labelFotnSize`}>
                    {label} {required && <span className='text-scogoorange'>*</span>} {` ${watch(name) || value} ${metric}`}
                </label>
            )}
            <input
                type="range"
                min={min}
                max={max}
                step={step}
                name={name}
                className="w-full mt-4"
                {...register(name, onChange)}
                defaultValue={value}
            />
        </div>
    )
}
